import { Table } from '@quintoandar-tokko/jopijs';
import styles from '../dashboardTables.module.scss';
import AgentBranchCell from '../components/AgentBranchCell';
import TrendCell from '../components/TrendCell';

export default function AgentsPerformanceTableRow({ row }) {
  const {
    id,
    agent,
    branch,
    assigned_contacts,
    saved_searches,
    shared_files,
    events,
    completed_operations,
  } = row;

  return (
    <Table.RowDefault id={id} variant="secondary">
      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <AgentBranchCell
          agentId={agent?.id}
          agentName={agent?.name}
          branchName={branch?.name}
          image={agent?.profile_picture}
          relativeSelector="#agents-performance"
          withImage
          withBranch
          withBoldTitle
          modal="agentsPerformance"
          tooltipStyles={{ left: '60px !important' }}
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <TrendCell
          value={assigned_contacts?.value}
          variation={assigned_contacts?.variation}
          percentageStatus={assigned_contacts?.percentage_status}
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <TrendCell
          value={saved_searches?.value}
          variation={saved_searches?.variation}
          percentageStatus={saved_searches?.percentage_status}
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <TrendCell
          value={shared_files?.value}
          variation={shared_files?.variation}
          percentageStatus={shared_files?.percentage_status}
          showValueOnNeutral
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <TrendCell
          value={events?.value}
          variation={events?.variation}
          percentageStatus={events?.percentage_status}
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <TrendCell
          value={completed_operations?.value}
          variation={completed_operations?.variation}
          percentageStatus={completed_operations?.percentage_status}
        />
      </Table.RowItemDefault>
    </Table.RowDefault>
  );
}
